module.exports = __webpack_public_path__ + "fonts/Inter-300-greek18.8c7f6ae.woff2";